import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UserService } from '../services';
import { User } from '../models';

export const IsAdminActivateGuard: CanActivateFn = (): Observable<boolean> =>  {
    return inject(UserService).getUserData().pipe(map((user: User) => user?.is_ops_admin || user?.is_admin));
}

